import { render, staticRenderFns } from "./EditorWithFile.vue?vue&type=template&id=973abaec&"
import script from "./EditorWithFile.vue?vue&type=script&lang=ts&"
export * from "./EditorWithFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports